import { Css, useTestIds } from "@homebound/beam";
import { formatCentsToPrice } from "src/utils";

type FormatOptionPriceOpts = { displayDirection?: boolean; trim?: boolean };

/**
 * Mirrors checkout's `formatDeltaPriceDisplay`: an option's price is the delta over its group's included option, so
 * zero reads as "Included" rather than "$0". Anything else is formatted as the caller asks, since not every page
 * signs its prices.
 */
export function formatOptionPrice(priceInCents: number, opts: FormatOptionPriceOpts = {}): string {
  return priceInCents === 0 ? "Included" : formatCentsToPrice(priceInCents, opts);
}

type OptionPriceProps = FormatOptionPriceOpts & { priceInCents: number };

/** `formatOptionPrice` as an element, with "Included" de-emphasized the way checkout shows it. */
export function OptionPrice(props: OptionPriceProps) {
  const { priceInCents, ...opts } = props;
  const tid = useTestIds(props, "price");
  return (
    <span css={Css.wsnw.if(priceInCents === 0).gray600.$} {...tid}>
      {formatOptionPrice(priceInCents, opts)}
    </span>
  );
}
